import axios from "axios";

// Tạo axios instance
const requestGHN = axios.create({
  baseURL: process.env.REACT_APP_API_GHN,
  timeout: 30000,
  headers: {
    "X-Custom-Header": "foobar",
    "Content-Type": "application/x-www-form-urlencoded",
    "X-Requested-With": "XMLHttpRequest",
    Token: process.env.REACT_APP_TOKEN_GHN,
  },
});
// Add a request interceptor
requestGHN.interceptors.request.use(
  function (config) {
    // Add OAuth 1.0a authentication to the request
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
requestGHN.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {

    return error.response.data;
  }
);

export default requestGHN;
